import React, { useState, useEffect, Fragment } from 'react';
import Grid from "@mui/material/Grid";
// import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
// import Checkbox from "@mui/material/Checkbox";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import EastIcon from "@mui/icons-material/East";
import LoadingButton from '@mui/lab/LoadingButton';
import { FormControl, MenuItem, InputLabel, Select } from "@mui/material";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import moment from 'moment';

import { useForm } from "react-hook-form";

import { DataGrid } from '@mui/x-data-grid';

import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import Paper from '@mui/material/Paper';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import Autocomplete from '@mui/material/Autocomplete';
// import PlusIcon from "@untitled-ui/icons-react/build/esm/Plus";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';


import CameraComponent from '../CameraComponent';
import CameraBasic from '../CameraBasic';  // น่าจะนาน ทำ layout ก่อน
import CameraAddMore from '../CameraAddMore';
const FACING_MODE_USER = { facingMode: 'user' }; // Front Camera
const FACING_MODE_ENVIRONMENT = { facingMode: { exact: 'environment' } }; // Back Camera
const DamageOtherItems = [
  { id: 1, displayFormat: 'B', name: 'ถ่ายรูปเพิ่มเติม', image: null },
];
// ถ้าเกิน 3 เอาแถวละ 3 ถ้าไม่ถึง 3 ขยายให้เต็มบรรทัด
const itemsCount = DamageOtherItems.length>3?3:DamageOtherItems.length;
const itemsCol = Math.floor(12/itemsCount);


export default function DamagedForm({ onSave, dataStep, saveAndBack, btnLoading }) {
    const [gender, setGender] = useState("");
    // const [birthday, setBirthday] = useState("");
    const [has_damaged, setHas_damaged] = useState("1");
    // const [education_qual, setEducation_qual] = useState('');
    // const [educationList, setEducationList] = useState([
    //     "ต่ำกว่ามัธยมศึกษาตอนปลาย / ปวช.",
    //     "มัธยมศึกษาตอนปลาย / ปวช.",
    //     "อนุปริญญา / ปวส.",
    //     "ปริญญาตรี",
    //     "ปริญญาโท หรือสูงกว่า"
    // ]);
    const [listDamage, setListDamage] = useState([]);
    // const [hasDamaged, setHasDamaged] = useState(false)
    const [previousData, setPreviousData] = useState(null);
    const [capturedImages, setCapturedImages] = useState(null);
    const [damage_detail, setDamage_detail] = useState(null);

    const { register, formState: { errors }, handleSubmit, setValue, reset } = useForm({});
    // const [user, setUser] = useState(null);

    useEffect(() => {
        getData();
    }, []);

    useEffect(() => {
        // reset form with previousData data
        reset(previousData);
    }, [previousData]);

    const onSubmit = (data) => {
      console.log("onsubmit",has_damaged,data);
      // console.log("listDamage",listDamage);
      // data.listDamage = listDamage;
        data.capturedImages = capturedImages;
        data.has_damaged = has_damaged;
        onSave(data);
    };

    const handleBack = () => {
        // console.log("new handleBack", data);
        // console.log("has_damaged",has_damaged);
        // console.log("listDamage",listDamage);
        setCapturedImages(capturedImages);
        setDamage_detail(damage_detail);

        const data = { 
            has_damaged : has_damaged,
            // listDamage : listDamage,
            capturedImages : capturedImages,
            damage_detail : damage_detail,
        }

        // console.log("will saveAndBack", data);
        saveAndBack(data);
    }

    function getData() {
        // console.log("getData",dataStep);
        if (dataStep !== "") {
            setPreviousData({
                has_damaged: dataStep.has_damaged,
                // listDamage: dataStep.listDamage,
                capturedImages: dataStep.capturedImages,
                damage_detail: dataStep.damage_detail,
            })
            // setListDamage(dataStep.listDamage);
            setHas_damaged(dataStep.has_damaged !== null ? dataStep.has_damaged : "0");
            setCapturedImages(dataStep.capturedImages);
            setDamage_detail(dataStep.damage_detail);
        }
    }

    function handleDamageDetailChange(e) {
      const { id, value } = e.target;
      setDamage_detail(value);
      console.log("setDamage_detail", damage_detail);
    }

    // const columns = [
    //   // { field: 'id', headerName: 'ID', width: 90 },
    //   {
    //     field: 'firstName',
    //     headerName: 'First name',
    //     width: 150,
    //     editable: true,
    //     filterable: false,
    //   },
    //   {
    //     field: 'lastName',
    //     headerName: 'ชิ้นส่วน',
    //     width: 150,
    //     editable: true,
    //     render: (text, record) =>
    //         <p>test</p>,
    //   },
    //   // {
    //   //   title: 'ชิ้นส่วน',
    //   //   dataIndex: 'partname',
    //   //   width: '30%',
    //   //   editable: true,
    //   // },
    //   {
    //     title: 'ประเภทความเสียหาย',
    //     dataIndex: 'damage_type',
    //     editable: true,
    //           // render: damage_type => (
    //           //   <span>
    //           //     {damage_type?damage_type.map(damage_type => {
    //           //       // let color = damage_type.length > 5 ? 'geekblue' : 'green';
    //           //       // if (damage_type === 'loser') {
    //           //       //   color = 'volcano';
    //           //       // }
    //           //       let color = '#108ee9'
    //           //       return (
    //           //         <Tag color={color} key={damage_type}>
    //           //           {damage_type.toUpperCase()}
    //           //         </Tag>
    //           //       );
    //           //       // return(
    //           //       //   <div>{damage_type}</div>
    //           //       // )
    //           //     }):[]
    //           //     }
    //           //   </span>
    //           // ),
    //   },
    //   {
    //     title: '#',
    //     dataIndex: 'operation',
    //     // render: (text, record) =>
    //     //   this.state.dataSource.length >= 1 ? (
    //     //     <Popconfirm title="Sure to delete?" onConfirm={() => this.props.handleDelete(record.obj_key)}>
    //     //       <a >ลบ</a>
    //     //     </Popconfirm>
    //     //   ) : null,
    //   },
    //   // {
    //   //   field: 'age',
    //   //   headerName: 'Age',
    //   //   type: 'number',
    //   //   width: 110,
    //   //   editable: true,
    //   // },
    //   // {
    //   //   field: 'fullName',
    //   //   headerName: 'Full name',
    //   //   description: 'This column has a value getter and is not sortable.',
    //   //   sortable: false,
    //   //   width: 160,
    //   //   valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
    //   // },
    // ];

    // function createData(name, calories, fat, carbs, protein) {
    //   return { name, calories, fat, carbs, protein };
    // }
    // const rows = [
    //   createData('Frozen yoghurt', 159, 6.0, 24, 4.0),
    //   createData('Ice cream sandwich', 237, 9.0, 37, 4.3),
    //   createData('Eclair', 262, 16.0, 24, 6.0),
    //   createData('Cupcake', 305, 3.7, 67, 4.3),
    //   createData('Gingerbread', 356, 16.0, 49, 3.9),
    // ];
    // const damageParts = [
    //   { partName: 'กันชนหน้า', partID: 1994 },
    //   { partName: 'กันชนหลัง', partID: 1974 },
    //   { partName: 'กระจกบังลมหน้าติดตั้ง', partID: 1957 },
    //   { partName: "ไฟหน้าซ้าย", partID: 1993 },
    //   { partName: 'ไฟหน้าขวา', partID: 1994 },
    //   { partName: 'ไฟท้ายซ้าย', partID: 1995 },
    //   { partName: 'ไฟท้ายขวา', partID: 1948 },
    //   { partName: 'บังโคลนหน้าซ้าย', partID: 1921 },
    //   { partName: 'บังโคลนหน้าขวา', partID: 2009 },
    //   { partName: 'แก้มหน้าซ้าย', partID: 2000 },
    //   { partName: 'แก้มหน้าขวา', partID: 2009 },
    // ];
    // const damage_type = [
    //     {desc: "บุบ"},
    //     {desc: "ครูด"},
    //     {desc: "ดุ้ง"},
    //     {desc: "ฉีก"},
    //     {desc: "แตก"},
    //     {desc: "สีเสื่อม"},
    //     {desc: "แผลเก่า"}
    // ];
    // const addListDamaged = () => {
    //   console.log("width",window.innerWidth);
    //     console.log("addListDamaged:listDamage ==> ", listDamage);
    //     let listDamaged = listDamage;
    //     const newListDamaged = {
    //         cl_vdmpID: "",
    //         partID: "",
    //         partname: "",
    //         damage_type_detail: "",
    //         // damaged_level: [],
    //         // LABOUR_COST: "",
    //         // SPRT_COST: "",
    //         // memo: "",
    //     };
    //     const updatedListDamaged = [...listDamage, newListDamaged];
    //     setListDamage(updatedListDamaged);
    //     console.log("new listDamage ==> ", listDamage);

    //     // let listDamaged = claimData.list_damage;
    //     // const newListDamaged = {
    //     //     cl_vdmpID: "",
    //     //     partname: "",
    //     //     damage_type_detail: "",
    //     //     damaged_level: [],
    //     //     LABOUR_COST: "",
    //     //     SPRT_COST: "",
    //     //     memo: "",
    //     // };
    //     // const updatedListDamaged = [...claimData.list_damage, newListDamaged];
    //     // setClaimData((prevState) => ({
    //     //     ...prevState,
    //     //     list_damage: updatedListDamaged,
    //     // }));
    // }

    // const onDamagePartsChange = (event, index, values) => {
    //   console.log("DamageParts Change", index, values);
    //   // let updateData = {}
    //   listDamage[index].partID = values.partID;
    //   listDamage[index].partname = values.partName;
    //   // listDamage[index] = updateData; //***
    //   setListDamage(listDamage);
    //   console.log("listDamage",listDamage);
    //   setPreviousData(null);
    // }

    // const onDamageTypeChange = (event, index, values) => {
    //   console.log("onDamageTypeChange", index, values);
    //   // let updateData = {}
    //   listDamage[index].damage_type_detail = values;
    //   // listDamage[index] = updateData; //***
    //   setListDamage(listDamage);
    //   console.log("listDamage",listDamage);
    // }


    const handleCapture = (capturedImages) => {
        console.log("handleCapture",capturedImages);
        console.log("handleCapture dataStep",dataStep);
        setValue('capturedImages', capturedImages);
        setCapturedImages(capturedImages);
    }

    const handleRemoveImage = (index, newImages, newTextImages) => {
        console.log("handleRemoveImage index", index, "newImages", newImages, "newTextImages", newTextImages);
        setCapturedImages((newImages) => newImages.filter((_, i) => i !== index));
        // setInputTextImagesData(Object.values(newTextImages).filter(item => item !== newTextImages[index]));


        setValue('capturedImages', capturedImages);
        // // setCapturedImages(newImages);
        // // setValue('capturedTextImages', newTextImages);
        // // setInputTextImagesData(newTextImages);
    }

    return (
        <React.Fragment>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={12}>
                        <FormControl xs={12} sm={12}>


                            <FormLabel id="demo-radio-buttons-group-label"></FormLabel>
                            <RadioGroup
                                aria-labelledby="demo-radio-buttons-group-label"
                                value={has_damaged}
                                name="radio-buttons-group"
                                {...register("has_damaged")}
                            >
                                <FormControlLabel onChange={(event) => {setHas_damaged("1")}} value="1" control={<Radio />} 
                                    label="มีความเสียหาย" />
      <Box sx={{ overflow: "auto" }}>
        <Box sx={{ width: "100%", display: "table", tableLayout: "fixed" }}>
                            <div id="has_damaged_group" style={{ display: has_damaged==1? 'block' : 'none' }}> 

                              <div className="container text-center pt-3">
                                <Grid item xs={12} sm={12}>
                                    <TextField
                                        {...register("damage_detail")}
                                        aria-invalid={errors.damage_detail ? "true" : "false"}
                                        fullWidth
                                        id="damage_detail"
                                        label="รายละเอียดความเสียหาย"
                                        multiline
                                        minRows={4}
                                        maxRows={4} // over max rows has scrollbar
                                        InputLabelProps={{ shrink: true, sx: { zIndex: 'auto' } }}
                                        onChange={handleDamageDetailChange}
                                    />
                                </Grid>
                              </div>

                                      {/*
                                        <Grid item xs={12} sm={12} style={{width:'100px',margin:'auto',padding:'5px'}}>
                                          <Button size={'small'}
                                            onClick={addListDamaged}
                                            // disabled={disabledForm()}
                                            style={{width:'100%', border: '1px solid', borderRadius:'20px'}}
                                            startIcon={<AddCircleOutlineIcon />}>
                                            Add
                                          </Button>
                                        </Grid>
                                      */}
                                      
                                        {/*
                                          <TableContainer component={Paper}>
                                              <Table sx={{ minWidth: 500 }} aria-label="simple table">
                                                <TableHead>
                                                  <TableRow>
                                            <TableCell align={"center"} style={{minWidth:'100',padding:'0px'}}>
                                              <div style={{color: '#FFF', backgroundColor: '#0d6efd', borderRadius: '20px 20px 5px 5px', padding: '6px', marginLeft: '2px'}}>ชิ้นส่วน</div>
                                            </TableCell>
                                            <TableCell align={"center"} style={{minWidth:'100',padding:'0px'}}>
                                              <div style={{color: '#FFF', backgroundColor: '#0d6efd', borderRadius: '20px 20px 5px 5px', padding: '6px', marginLeft: '2px'}}>ประเภท</div>
                                            </TableCell>
                                                  </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                  { 
                                                    listDamage.length > 0?listDamage.map((item, index) => (
                                                    <TableRow
                                                      key={item.name}
                                                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                      <td style={{minWidth:250}}>
                                                        <Autocomplete
                                                          disablePortal
                                                          options={damageParts}
                                                          getOptionLabel={(option) => option.partName?.toString() || ''} // เลือกดึงค่าอื่น ที่ไม่ใช่ label ได้
                                                          isOptionEqualToValue={(option, value) => option.partID === value.partID}
                                                          // value={item.partname ? (damageParts.find((item_Parts) => item_Parts.partName == item.partname)) : []} // เลือก-ไม่เปลี่ยน ย้อนไปมา-แสดง
                                                          // value={{partName: 'บังโคลนหน้าซ้าย', partID: 2000}}
                                                          // value={item?.partname? (damageParts.find((item_Parts) => item_Parts.partName == item.partname)) : []} // เลือก-ไม่เปลี่ยน ย้อนไปมา-แสดง
                                                          // value={listDamage[index].partname}
                                                          onChange={(event, newValue, reason) => {
                                                              console.log("previousData", previousData)
                                                              console.log("newValue", newValue)
                                                              console.log("index", index)
                                                              console.log("reason", reason)
                                                              onDamagePartsChange(event,index,newValue)
                                                          }}
                                                          // onInputChange={(event, newInputValue, reason) => {
                                                          //     console.log("newInputValue", newInputValue)
                                                          //     console.log("reason", reason)
                                                          //   // setInputValue(newInputValue);
                                                          // }}
                                                          // filterSelectedOptions
                                                          // sx={{ width: 300 }}
                                                          renderInput={(params) => 
                                                            <TextField {...params}
                                                                placeholder="ชิ้นส่วน" hiddenLabel={true}
                                                                value={listDamage[index].partname?listDamage[index].partname : item.partname} // เลือก-เปลี่ยน ย้อนไปมา-ไม่แสดง
                                                                // value={{partName: 'แก้มหน้าซ้าย', partID: 2000}}
                                                                // value={listDamage[index].partname?{partName: "แก้มหน้าขวา", partID: 2009} : {partName: 'แก้มหน้าซ้าย', partID: 2000}}
                                                            />
                                                          }
                                                        />
                                                      </td>
                                                      <td style={{maxWidth:250}}>
                                                        <Autocomplete
                                                            multiple
                                                            options={damage_type}
                                                            // onChange={onDamageTypeChange}
                                                            getOptionLabel={(option) => option.desc.toString()} // เลือกดึงค่าอื่น ที่ไม่ใช่ label ได้
                                                            isOptionEqualToValue={(option, value) => option.desc === value.desc}
                                                            filterSelectedOptions // option ที่เลือกแล้ว จะถูก filter ออก
                                                            onChange={(event, newValue) => {
                                                                // console.log("newValue", newValue)
                                                                // console.log("index", index)
                                                                onDamageTypeChange(event,index,newValue)
                                                            }}
                                                            renderInput={(params) => (
                                                              <TextField {...params}
                                                                placeholder="" hiddenLabel={true}
                                                                
                                                              />
                                                            )}
                                                        />
                                                      </td>
                                                    </TableRow>
                                                  ))
                                                  :null
                                                  }
                                                </TableBody>
                                              </Table>
                                            </TableContainer>
                                        */}

                                {/*<CameraComponent items={DamageOtherItems} itemsCol={itemsCol} />
                                <CameraBasic items={DamageOtherItems} itemsCol={itemsCol} />
                                <CameraAddMore btnText="ถ่ายรูปเพิ่มเติม"
                                  onCapture={handleCapture}
                                  onRemoveImage={handleRemoveImage}
                                  previousData={dataStep.capturedImages?dataStep.capturedImages:null}
                                />*/}
                            </div>
        </Box>
      </Box>


                                <FormControlLabel onChange={(event) => {setHas_damaged("0");console.log("set has 0");}} value="0" control={<Radio />} 
                                    label="ไม่มีความเสียหาย" />

                            </RadioGroup>
                        </FormControl>
                    </Grid>

                    

                </Grid>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                    }}
                >

                    <Button onClick={handleBack}
                      sx={{ mt: 3, ml: 1, position: 'static' }}
                        // เดิมของ MUI เป็น position: 'relative' แล้วมันไปทับกับ position ของกล้อง
                    >
                        ย้อนกลับ
                    </Button>
                    <LoadingButton
                        variant="contained"
                        type="submit"
                        endIcon={<EastIcon />}
                        sx={{ mt: 3, ml: 1, position: 'static' }}
                        // เดิมของ MUI เป็น position: 'relative' แล้วมันไปทับกับ position ของกล้อง
                        loading={btnLoading}
                        loadingPosition="start"
                    >
                        ถัดไป
                    </LoadingButton>


                    
                </Box>
            </form>
        </React.Fragment>
    );
}
